import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationExtras } from '@angular/router';
import { AuthService } from '../services/authenticate.service';

@Injectable()
export class AuthGuard  {
    constructor(
        private authService: AuthService,
        private router: Router,
    ) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        try {
            let _showMenu: boolean = true;
            if (this.authService.getIsPasswordSet() == 'false') {
                _showMenu = false;
              }
          
            const claims: any = this.authService.getToken();
            let hasAccess = false;
            if (claims != null) {
                hasAccess = true;
            }
            if (hasAccess && !_showMenu) {
                this.router.navigate(['/change-password']);
            } else  if (!hasAccess || !_showMenu) {
                this.router.navigate(['/login']);
            }
            return hasAccess;
        } catch (error) {
            console.log(error);
            return false;
        }
    }
}
